import { http, type ObjectValue } from '@kunlun/dependencies';

export type productItem = {
  name: string;
  code: string;
}
export interface IQueryTaskDetailItem {
  itemDetailList: productItem[]
  errorInfos: string[];
}
export const matchProductApi = async (
  params: {
    code: string;
  },
  variables: ObjectValue
) => {

  const gql = `
    query {
      retailItemScheduleTaskItemDetailQuery{
        matchItem(data: {
        code:"${params.code}"
        }){
          itemDetailList{
			      code
			      name
		      }
		    errorInfos
        }
      }
    }
  `;

  const res = await http.query<IQueryTaskDetailItem>('deliRetail', gql, variables);
  return res.data.retailItemScheduleTaskItemDetailQuery.matchItem;
};
